import React from 'react';
import styles from './ClubHero.module.css';
import ClubOverview from './ClubOverview';
import OptimizedImage from '../player/OptimizedImage';
import { ClubFallbackImage } from '../custom-widgets/ImageAssets';
import { API_HOST } from '../../../server/services/custom-pages/constants';

export default function ClubHero({ club }) {
    const fallbackSrc = "/club/fallback-club.png";
    const hasHeroImage = club.heroImage && club.heroImage.length > 5;
    console.log("[ClubHero] logoUrl:", club.logoUrl, "typeof:", typeof club.logoUrl, "isArray:", Array.isArray(club.logoUrl));

    return (
        <header className={styles.hero}>
            <div className={styles.venueBackground}>
                {hasHeroImage ? (
                    <OptimizedImage
                        src={club.heroImage}
                        fallbackSrc={"/club/fallback-club.png"}
                        alt="Venue background"
                        layout="fill"
                        objectFit="cover"
                        unoptimized
                        className={styles.venueImage}
                    />
                ) : (
                    <ClubFallbackImage className={styles.venueImage} />
                )}
                <div className={styles.venueOverlay} />
            </div>

            <div className={styles.heroHeaderRow}>
                {club.logoUrl ? (
                    <div className={`${styles.crest} ${styles.hasLogo}`} aria-label={`${club.name} crest`}>
                        <OptimizedImage src={club.logoUrl} fallbackSrc={"/club/fallback-club.png"} alt="" width={60} height={60} unoptimized className={styles.logoImg} />
                    </div>
                ) : (
                    <div className={styles.crest} style={{ visibility: 'hidden' }} />
                )}

                <div className={styles.namePlate}>
                    <div className={styles.nameOutline}>
                        <h1 className={styles.transparentName}>
                            {club.displayName}
                        </h1>
                    </div>
                </div>
            </div>

            <div className={styles.overviewWrapper}>
                <h2 className={styles.overviewTitle}>Overview</h2>
                <div className={styles.overviewScrollArea}>
                    <ClubOverview
                        items={[
                            { label: 'Club', value: club.name },
                            ...club.overview
                        ]}
                        variant="hero"
                    />
                </div>
            </div>
        </header>
    );
}
